/** sessionStorage: uma chave por aba/janela do chat sandbox. */
export const SANDBOX_CLIENT_KEY_STORAGE = "bot-ops-sandbox-client-key";
export const SANDBOX_CLIENT_KEY_HEADER = "X-Bot-Ops-Sandbox-Client";

const CLIENT_KEY_RE = /^[a-zA-Z0-9_-]{8,128}$/;

function randomKey() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID().replace(/-/g, "");
    }
    return `k${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
}

/** Fallback em memória se sessionStorage estiver bloqueado. */
let memoryKey = null;

/**
 * Retorna (ou cria) o client_key desta aba.
 * sessionStorage isola abas; F5 na mesma aba reutiliza a conversa.
 */
export function getOrCreateSandboxClientKey() {
    try {
        if (typeof sessionStorage !== "undefined") {
            const existing = sessionStorage.getItem(SANDBOX_CLIENT_KEY_STORAGE);
            if (existing && CLIENT_KEY_RE.test(existing)) return existing;
            const created = randomKey();
            sessionStorage.setItem(SANDBOX_CLIENT_KEY_STORAGE, created);
            return created;
        }
    } catch {
        /* private mode / blocked */
    }
    if (!memoryKey || !CLIENT_KEY_RE.test(memoryKey)) {
        memoryKey = randomKey();
    }
    return memoryKey;
}

/** Só para testes. */
export function __resetSandboxClientKeyForTests() {
    memoryKey = null;
    try {
        sessionStorage?.removeItem(SANDBOX_CLIENT_KEY_STORAGE);
    } catch {
        /* ignore */
    }
}
